import React from 'react';
import styled, { css } from 'styled-components';
import { getNeutralColors } from '@panel/commons/lib/theme';
import { BodyText, Headings } from '@panel/commons/lib/typography';
import { ModalBase } from '@panel/commons';
import { useModal } from './useModal';
import Mobile from './Mobile';
import ProgressBar from './progressBar';

const ModalWrapper = styled.div`
  background: ${({ mobileHeader }) => (mobileHeader ? 'transparent' : 'rgba(0, 0, 0, 0.6)')};
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: ${({ mobileHeader }) => (mobileHeader ? '-60px' : '0')};
  z-index: 9999;
`;

const ModalTitle = styled.div`
  padding: 20px 24px 8px;
  width: 100%;
  ${({ isBorder }) =>
    isBorder &&
    css`
      padding: 10px 20px;
      border-bottom: 1px solid ${getNeutralColors('grisMedioClaro')};
    `}
`;

const ModalContent = styled.div`
  padding: ${({ timer }) => (timer ? '0px' : '8px')} 16px 16px;
`;

const Modal = ({
  children,
  title,
  width = 'fit-content',
  breakpoint = 'desktop',
  handleClose,
  border = false,
  withoutCloseButton = false,
  withoutOutsideClose = false,
  timer = null,
  noAnimation = false,
  showTopBar = false
}) => {
  const { letToggleModal, toggleModal } = useModal();

  const closeModal = () => {
    if (handleClose) {
      handleClose();
    } else {
      letToggleModal(false);
    }
  };

  const ShowModal = () => {
    if (breakpoint === 'mobile')
      return (
        <ModalWrapper mobileHeader={withoutCloseButton}>
          <Mobile
            title={title}
            onClose={closeModal}
            noAnimation={noAnimation}
            withoutCloseButton={withoutCloseButton}
            noHeader={withoutCloseButton}
            showTopBar={showTopBar}
          >
            {timer && <ProgressBar time={timer} />}
            {children}
          </Mobile>
        </ModalWrapper>
      );

    return (
      <ModalWrapper>
        <ModalBase
          openModal={toggleModal}
          onClose={closeModal}
          width={width}
          withoutCloseButton={withoutCloseButton}
          withoutOutsideClose={withoutOutsideClose}
        >
          {timer && <ProgressBar time={timer} />}
          {title && (
            <ModalTitle isBorder={border}>
              {border ? <BodyText size={100}>{title}</BodyText> : <Headings size={400}>{title}</Headings>}
            </ModalTitle>
          )}
          <ModalContent timer={timer}>{children}</ModalContent>
        </ModalBase>
      </ModalWrapper>
    );
  };

  return <>{toggleModal && <ShowModal />}</>;
};

export { Modal };
